var _g, _path, _g2, _path2, _g3, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 46,
    viewBox: "0 0 37 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4674_6180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4947 34.5448L16.8626 22.1984H16.9246L20.2718 34.5448H22.152L26.3876 19.7292H24.4867L21.2429 32.1586H21.1602L17.813 19.7292H15.9742L12.6063 32.1586H12.5236L9.27977 19.7292H7.37891L11.6145 34.5448H13.4947Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0039 12.1816L23.8223 0.999999C23.8223 7.17541 28.8285 12.1816 35.0039 12.1816Z",
    fill: "#B5C8FC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_4674_6180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4947 34.5448L17.8626 22.1984H17.9246L21.2718 34.5448H23.152L27.3876 19.7292H25.4867L22.2429 32.1586H22.1602L18.813 19.7292H16.9742L13.6063 32.1586H13.5236L10.2798 19.7292H8.37891L12.6145 34.5448H14.4947Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0039 12.1816L24.8223 0.999999C24.8223 7.17541 29.8285 12.1816 36.0039 12.1816Z",
    fill: "#B5C8FC"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_4674_6180)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9999 0.605103H0.769531V45.3339H36.9999V11.7869L25.8181 0.605117L36.9999 0.605103Z",
    fill: "#FA4E4E"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1485 30.7284C24.6392 30.6163 23.1861 30.0558 22.0122 29.0469C19.7204 29.5512 17.5402 30.2797 15.3602 31.1768C13.6275 34.2594 12.0064 35.8289 10.6089 35.8289C10.3294 35.8289 9.99416 35.773 9.77052 35.6047C9.1555 35.3246 8.82031 34.7079 8.82031 34.0914C8.82031 33.5868 8.93213 32.1857 14.2423 29.8875C15.4723 27.6455 16.4223 25.3475 17.205 22.9375C16.5341 21.5923 15.0809 18.2851 16.0868 16.6039C16.4223 15.9872 17.0932 15.6509 17.82 15.7071C18.3789 15.7071 18.9377 15.9872 19.2732 16.4356C20 17.4445 19.9441 19.5744 18.9936 22.7133C19.8882 24.3924 21.0599 25.9084 22.4592 27.1973C23.6334 26.9728 24.8069 26.8048 25.9808 26.8048C28.6081 26.8607 28.9994 28.0939 28.9435 28.8227C28.9435 30.7284 27.0987 30.7284 26.1485 30.7284ZM10.4974 34.2033L10.6651 34.1473C11.4476 33.8672 12.0623 33.3067 12.5096 32.5779C11.6709 32.9142 11.0003 33.4747 10.4974 34.2035V34.2033ZM17.9316 17.3886H17.7638C17.7079 17.3886 17.5961 17.3886 17.5402 17.4445C17.3165 18.3972 17.4843 19.4061 17.8757 20.3029C18.2111 19.3502 18.2111 18.3413 17.9316 17.3886ZM18.3229 25.5158L18.267 25.6276L18.2111 25.5717C17.7079 26.861 17.1488 28.1501 16.5341 29.3832L16.6459 29.3273V29.4391C17.8889 28.9884 19.1583 28.614 20.447 28.3181L20.3911 28.2622H20.5588C19.7202 27.4213 18.9377 26.4685 18.3229 25.5158ZM25.9249 28.4864C25.4217 28.4864 24.9747 28.4864 24.4715 28.5982C25.0306 28.8786 25.5897 28.9907 26.1485 29.0469C26.5399 29.1028 26.9313 29.0469 27.2665 28.9348C27.2665 28.7665 27.0428 28.4864 25.9249 28.4864Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 11.7873L25.8178 0.605123C25.8178 6.78088 30.8242 11.7873 37 11.7873Z",
    fill: "#FDB8B8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4674_6180",
    x: 6.37891,
    y: 18.7292,
    width: 28.0078,
    height: 25.8156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4674_6180"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4674_6180",
    result: "effect2_dropShadow_4674_6180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4674_6180",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_4674_6180",
    x: 7.37891,
    y: 18.7292,
    width: 28.0078,
    height: 25.8156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4674_6180"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4674_6180",
    result: "effect2_dropShadow_4674_6180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4674_6180",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_4674_6180",
    x: 0.769531,
    y: -0.394897,
    width: 36.2305,
    height: 46.7288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4674_6180"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4674_6180",
    result: "effect2_innerShadow_4674_6180"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.4d4effd0e7d04d1997e50262d2c88e03.svg";
export { ForwardRef as ReactComponent };